import { STATIC_BASE_PATH as i } from "../../../constants.js";
const o = `${i}/home`, u = (a) => {
  const { language: e, getTranslation: t } = a;
  return [
    {
      image: `${o}/about-technology.webp`,
      description: t("about.menu.ai-technology-description"),
      title: t("about.menu.ai-technology"),
      path: `/${e}/about/ai-technology`
    },
    {
      image: `${o}/about-network.webp`,
      description: t("about.menu.legal-network-description"),
      title: t("about.menu.legal-network"),
      path: `/${e}/about/legal-network`
    },
    {
      image: `${o}/about-company.webp`,
      description: t("about.menu.company-description"),
      title: t("about.menu.company"),
      path: `/${e}/about/company`
    },
    {
      image: `${o}/about-careers.webp`,
      description: t("about.menu.careers-description"),
      title: t("about.menu.careers"),
      path: `/${e}/about/careers`
    },
    {
      image: `${o}/about-sailing.webp`,
      description: t("about.menu.sailing-description"),
      title: t("about.menu.sailing"),
      path: `/${e}/about/sailing`
    }
  ];
};
export {
  u as getAboutLinks
};
